import { useSelector } from "react-redux";
import { getNodeStructureWithTraversal } from "../redux/slice/structureSlice";

function useNodeTraversal(id) {
  const element = useSelector(getNodeStructureWithTraversal(id));

  return element;
}

export default useNodeTraversal;
